import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ErrorEventEntitiesState} from './error-event-entities.state';
import {errorEventEntitiesAdapter} from './error-event-entities.adapter';
import {ExportJobDTO} from '../../openapi/export-openapi';
import {SelectorCache} from '../utils/selector-cache.util';


export const ERROR_EVENT_ENTITIES_FEATURE_KEY = 'errorEventEntities';

export class ErrorEventEntitiesSelectors {

  private static readonly _adapterSelectors = errorEventEntitiesAdapter.getSelectors();

  private static readonly _feature = createFeatureSelector<ErrorEventEntitiesState>(ERROR_EVENT_ENTITIES_FEATURE_KEY);

  private static readonly _selectorCache = new SelectorCache<ExportJobDTO | undefined>();

  public static readonly all = createSelector(
    this._feature,
    this._adapterSelectors.selectAll,
  );

  public static readonly loadLoading = createSelector(
    this._feature,
    (state) => state.loadLoading
  );

  public static readonly loadLoaded = createSelector(
    this._feature,
    (state) => state.loadLoaded
  );

  public static readonly errorEventById = (jobId: string | undefined) => {
    // INFO: Kein jobId? Gib undefined Selector zurück
    if (!jobId) {
      return createSelector(
        this._feature,
        () => undefined
      );
    }

    return this._selectorCache.getOrCreate(
      `errorEvent_${jobId}`,
      () => createSelector(
        this._feature,
        (state) => this._adapterSelectors.selectEntities(state)[jobId] ?? undefined
      )
    );
  };

}
